<div id="followingBallsG">
  <div id="followingBallsG_1" class="followingBallsG"></div>
  <div id="followingBallsG_2" class="followingBallsG"></div>
  <div id="followingBallsG_3" class="followingBallsG"></div>
  <div id="followingBallsG_4" class="followingBallsG"></div>
</div>
